import {
  useEffect,
  useState
} from "react";

import useMedia from "../../hooks/useMedia";

import MediaToolbar from "../headers/MediaToolbar";
import MediaTable from "../tables/MediaTable";
import useDebounce from "../../hooks/useDebounce";
import useSelection from "../../hooks/useSelection";
import Pagination from "../common/Pagination";
import UploadMediaDialog from "../dialogs/UploadMediaDialog";
import BulkToolbar from "../bulk/BulkToolbar";

export default function MediaPickerDialog({

  folder = "",

  open,

  onClose,

  onSelect,

}) {

  const {

    loadMedia

  } = useMedia();

  const [

    loading,

    setLoading

  ] = useState(false);

  const [

    rows,

    setRows

  ] = useState([]);
 
  const [

    moveOpen,

    setMoveOpen

  ] = useState(false);
  const [

    copyOpen,

    setCopyOpen

  ] = useState(false);
  const [

    addOpen,

    setAddOpen

  ] = useState(false);
  const [

    uploadOpen,

    setUploadOpen

  ] = useState(false);
  const [

    filters,

    setFilters

  ] = useState({

    search: "",

    folder: folder,

    mimeGroup: "",

    sort: "id",

    order: "DESC",

    page: 1,

    limit: 20

  });
  const {
  
      selected,
  
      selectedCount,
  
      toggle,
  
      toggleAll,
  
      isSelected,
  
      clear,
  
      allSelected
  
  }
  
  =
  
  useSelection(
      rows
  );
  const debouncedSearch =
    useDebounce(
      filters.search,
      300
    );
    const [
  
      pagination,
  
      setPagination
  
  ] = useState(null);
 async function load() {

  try {

    setLoading(true);

    const result =
      await loadMedia({

        ...filters,

        search:
          debouncedSearch

      });

    setRows(
      result.rows
    );


    
      setPagination(
    result.pagination
);
  } finally {

    setLoading(false);

  }

}

 useEffect(() => {

    if(!open){

        return;

    }

    load();

}, [

    open,

    debouncedSearch,

    filters.folder,

    filters.mimeGroup,

    filters.sort,

    filters.order,

    filters.page,

    filters.limit

]);
  useEffect(() => {

    setFilters(

      previous => ({

        ...previous,

        folder

      })

    );

  }, [

    folder

  ]);

  if (!open) {

    return null;

  }

  return (

    <div className="picker-overlay">

      <div className="picker-dialog">

        <div className="picker-header">

          <div>

            <h2>

              Select Media

            </h2>

            <p>

              Browse existing files from your media library.

            </p>

          </div>

          <button

            className="picker-close"

            onClick={onClose}

          >

            ✕

          </button>

        </div>

        <div className="picker-toolbar">

          {
          
            
          
              <MediaToolbar
          
                  filters={filters}
          
                  onChange={setFilters}
          
              />
          
          }

        </div>

        <div className="picker-body">

          <MediaTable

            pickerMode

            loading={loading}

            rows={rows}

            onSelect={media => { 

              onSelect?.(
                media
              );


            }}

            
  pagination={pagination}
    setFilters={setFilters}


    selected={selected}

    isSelected={isSelected}

    toggle={toggle}

    toggleAll={toggleAll}

    allSelected={allSelected}

          />

        </div>

        <div className="picker-footer">
          <div style={{position:"relative",margin:"5px",top:"-18px",height:"40px"}}> <Pagination
          
              pagination={pagination}
          
              onPageChange={page =>
          
                  setFilters(previous => ({
          
                      ...previous,
          
                      page
          
                  }))
          
              }
          
          /></div>
          <button

            className="btn btn-primary"

            onClick={()=>setUploadOpen(true)}

          >

           upload

          </button>

          <button

            className="btn"

            onClick={onClose}

          >

            Close

          </button>

        </div>
    
          <UploadMediaDialog
    
            open={
              uploadOpen 
            }
    
            onClose={() =>
              setUploadOpen(
                false
              )
            }
    
            onSuccess={() => {
    
              setUploadOpen(
                false
              );
    
              load();
    
            }}
    
          />
      </div>
<style>{`.picker-overlay{

    position:fixed;

    inset:0;

    background:rgba(15,23,42,.45);

    display:flex;

    justify-content:center;

    align-items:center;

    padding:24px;

    z-index:9999;

}

.picker-dialog{
   position:relative;
    width:min(1150px,95vw);
top:0px;
    max-height:90vh;

    background:#FFFFFF;

    border-radius:22px;

    display:flex;

    flex-direction:column;

    overflow:hidden;

    box-shadow:0 30px 80px rgba(15,23,42,.25);

}

.picker-header{

    display:flex;

    justify-content:space-between;

    align-items:flex-start;

    padding:24px 30px;

    border-bottom:1px solid #E5E7EB;

}

.picker-header h2{

    margin:0;

    font-size:26px;

    color:#111827;

}

.picker-header p{

    margin-top:8px;

    color:#6B7280;

}

.picker-close{

    width:40px;

    height:40px;

    border:none;

    border-radius:10px;

    background:#F3F4F6;

    cursor:pointer;

    transition:.2s;

}

.picker-close:hover{

    background:#E5E7EB;

}

.picker-toolbar{

    padding:20px 30px;

    border-bottom:1px solid #E5E7EB;

    background:#FFFFFF;

}

.picker-body{

    flex:1;

    overflow:auto;

    padding:24px;

    background:#F8FAFC;

}

.picker-footer{

    display:flex;

    justify-content:flex-end;
    flex-wrap:wrap;
    padding:20px 30px; gap:10px;

    border-top:1px solid #E5E7EB;

    background:#FFFFFF;

}`}</style>
    </div>

  );

}